function prepareLeaderboardsData(leaderboards) {
    return leaderboards.map(_ => ({
        vehicle_level: _.vehicle_level,
        enabled: _.show_leaderboard,
    })).sort((a, b) => b.vehicle_level - a.vehicle_level)
}

export default function prepareMeta(meta) {
    return {
        updatedAt: meta.updated_at,
        recalculationPeriod: meta.recalculation_period,
        leaderboardsVisibility: prepareLeaderboardsData(meta.leaderboards_visibility),
        required_battles_count: meta.required_battles_count,
    }
}



// WEBPACK FOOTER //
// ./state/actions/helpers/leaderboards.js